import { MouseEvent } from 'react';

import moment from 'moment';
import { T } from 'react-translator-component';

import { ChargePoint } from './../types/responses/ChargePoints';

export const normalOrder = (orderedField, list, callback, e: MouseEvent<HTMLDivElement>) => {
  const objects = list;
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');

  if (objects.length) {
    objects.sort((a, b) => {
      const A = a[orderedField];
      const B = b[orderedField];

      if (A > B) {
        return !isOrdered ? 1 : -1;
      }
      if (A < B) {
        return !isOrdered ? -1 : 1;
      }

      return 0;
    });
    callback(objects);
  }
};

export const orderByUF = (list: ChargePoint[], callback, e: MouseEvent<HTMLDivElement>) => {
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');
  const objects = list;

  if (objects.length) {
    objects.sort((a, b) => {
      const A = a.address.state?.trim() ? a.address.state.toUpperCase() : 'Z';
      const B = b.address.state?.trim() ? b.address.state.toUpperCase() : 'Z';

      if (A < B) {
        return isOrdered ? 1 : -1;
      }
      if (A > B) {
        return isOrdered ? -1 : 1;
      }

      return 0;
    });
    callback(objects);
  }
};

export const orderByCity = (list: ChargePoint[], callback, e: MouseEvent<HTMLDivElement>) => {
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');
  const objects = list;

  if (objects.length) {
    objects.sort((a, b) => {
      const A = a.address.city?.trim() ? a.address.city.toUpperCase() : 'Z';
      const B = b.address.city?.trim() ? b.address.city.toUpperCase() : 'Z';

      if (A < B) {
        return isOrdered ? 1 : -1;
      }
      if (A > B) {
        return isOrdered ? -1 : 1;
      }

      return 0;
    });
    callback(objects);
  }
};

export const orderByHearbeat = (list, callback, e: MouseEvent<HTMLDivElement>) => {
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');
  const objects = list;

  if (objects.length) {
    objects.sort((a, b) => {
      const A = a.lastHeartbeatTimestamp.replace(/-|:/g, '').trim();
      const B = b.lastHeartbeatTimestamp.replace(/-|:/g, '').trim();

      if (A < B) {
        return isOrdered ? 1 : -1;
      }
      if (A > B) {
        return isOrdered ? -1 : 1;
      }
      return 0;
    });
    callback(objects);
  }
};

export const orderByCarName = (list, callback, e: MouseEvent<HTMLDivElement>) => {
  const objects = list;
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');

  if (objects.length) {
    objects.sort((a, b) => {
      const carNameA =
        a?.car_name || (a?.cars?.length && `${a?.car_brand_name} ${a?.car_model_name}`) || T('Undefined');

      const carNameB =
        b?.car_name || (b?.cars?.length && `${b?.car_brand_name} ${b?.car_model_name}`) || T('Undefined');

      const A = carNameA;
      const B = carNameB;

      if (A < B) {
        return !isOrdered ? -1 : 1;
      }
      if (A > B) {
        return !isOrdered ? 1 : -1;
      }

      return 0;
    });
    callback(objects);
  }
};

export const orderByTime = (list, callback, e: MouseEvent<HTMLDivElement>) => {
  const objects = list;
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');

  if (objects.length) {
    objects.sort((a, b) => {
      const A = moment(a.startTimestamp, 'DD/MM/YYYY hh:mm:ss')
        .format('YYYY-MM-DD hh:mm:ss')
        .replace(/-|:/g, '')
        .trim();
      const B = moment(b.startTimestamp, 'DD/MM/YYYY hh:mm:ss')
        .format('YYYY-MM-DD hh:mm:ss')
        .replace(/-|:/g, '')
        .trim();

      if (A > B) {
        return isOrdered ? 1 : -1;
      }
      if (A < B) {
        return isOrdered ? -1 : 1;
      }

      return 0;
    });
    callback(objects);
  }
};

export const twoOrMoreWordsOrder = (orderedField, list, callback, e: MouseEvent<HTMLDivElement>) => {
  const isOrdered = e.currentTarget.querySelector('.header_icon_gabrr')?.classList.contains('active');
  const objects = list;

  if (objects.length) {
    objects.sort((a, b) => {
      const A = (!!a[orderedField].trim() && a[orderedField].toUpperCase()) || 'Z';
      const B = (!!b[orderedField].trim() && b[orderedField].toUpperCase()) || 'Z';

      if (A < B) {
        return isOrdered ? 1 : -1;
      }
      if (A > B) {
        return isOrdered ? -1 : 1;
      }

      return 0;
    });
    callback(objects);
  }
};
